module.exports = __webpack_public_path__ + "static/media/PCA200228980.7f68dace.pdf";